<template>
  <div class="NextStepsOnboarding text-center">
    <h1 class="font-family-display font-weight-bold mb-8">
      {{ $t('awesome') }}
      <br />
      {{ $t('you_have_registered') }}
    </h1>
    <p class="mb-24">
      {{ $t('check_activation_email') }}
      <router-link :to="{ name: 'Login' }">
        {{ $t('back_to_login') }}
      </router-link>
    </p>
    <div class="NextStepsOnboarding__inner">
      <img
        class="NextStepsOnboarding__img"
        src="/illustration_medidate.svg"
        alt="Illustration of person in a meditation position"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useOnboardingStore } from '@/stores/onboardingStore'

const onboardingStore = useOnboardingStore()

onMounted(() => onboardingStore.$reset())
</script>

<style lang="scss" scoped>
.NextStepsOnboarding {
  padding: 0 rem(16);

  &__inner {
    max-width: rem(400);
    margin: 0 auto;
  }

  &__img {
    max-width: 100%;
  }
}
</style>
